import { Injectable } from "@angular/core";
import { IPortaleContratti } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDPortaleContrattiStore } from "./iidPortaleContratti.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
    providedIn: 'root'
  })
  @InterfaceDataQuery(InterfaceName.PORTALE_CONTRATTI)
  export class IIDPortaleContrattiQuery extends AbstractInterfaceDataQuery<IPortaleContratti> {
  
    constructor(protected store: IIDPortaleContrattiStore) {
      super(store);
    }
  }
